import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgenteAsignarDel = async (credentials, data) => {
  const body = {
    service: "RNHAgenteAsignarDel",
    params: {
      rnhAgenteLugarId: data?.lugarId || null,
      rnhAgenteLugarVersion: data?.lugarVersion ?? null,
    }
  }

  return respuestaDe(await axiosPost(body, credentials));
}
